import PropTypes from 'prop-types';
import React, { useContext, useMemo, useRef } from 'react';
import {
  Button as BootstrapButton,
  Card,
  OverlayTrigger,
  Tooltip,
} from 'react-bootstrap';

import Icon from '../icon/Icon';
import AddOnIcon from '../icon/common/AddOnIcon';
import { getAddOnConfig } from '../mapView/drawingManager/utilities';

export const IconWrapper = ({
  icon,
  isActive,
  isDisabled,
  isSecondary,
  ...restProps
}) => {
  const isAddOn = !!getAddOnConfig(icon);
  if (!isAddOn) {
    return (
      <Icon
        icon={icon}
        isActive={isActive}
        isDisabled={isDisabled}
        isSecondary={isSecondary}
        {...restProps}
      />
    );
  }

  let iconName = `${icon}${isActive ? '_white' : ''}`;

  if (isDisabled || isSecondary) {
    iconName = `${icon}_disabled`;
  }

  return <AddOnIcon icon={iconName} {...restProps} />;
};

IconWrapper.propTypes = {
  icon: PropTypes.string.isRequired,
  isActive: PropTypes.bool,
  isDisabled: PropTypes.bool,
  isSecondary: PropTypes.bool,
};

IconWrapper.defaultProps = {
  isActive: false,
  isDisabled: false,
  isSecondary: false,
};
